<div class="password-reset-email-sent-container container-fluid h-100">
  <div class="row">
    <div class="col-12">
      <a [href]="links.home">
        <om-logo class="mx-auto mt-5"></om-logo>
      </a>
    </div>
  </div>

  <div class="row text-center mb-4">
    <div class="col-10 offset-1 col-md-6 offset-md-3">
      <h1 class="mt-5">Email sent</h1>
      <p class="body p-0"
        >Password reset instructions have been sent to {{ email }}. Please check your email and follow the instructions
        to reset your password.</p
      >
    </div>
  </div>

  <div class="row">
    <div class="col-10 offset-1 col-md-6 offset-md-3">
      <div class="d-grid gap-3 mb-4">
        <omgui-button
          [variant]="OmguiButtonVariant.primary"
          [size]="OmguiButtonSize.fillParent"
          [type]="OmguiButtonType.button"
          (buttonClick)="onBackToLogin()"
        >
          Back to log in
        </omgui-button>
      </div>

      <div class="mt-5 mb-5">
        <p class="body-small p-0 mb-3 fw-bold">Haven't received the email within 30 minutes?</p>
        <ul class="list-unstyled text-start p-0 mb-3">
          <li class="body-small mb-2"
            ><span class="me-2">•</span>If you typically sign in using your Amazon account, return to the login page and
            select "Log in with Amazon"</li
          >
        </ul>
      </div>

      <p class="body-small text-center">
        For additional support, contact us at
        <a href="mailto:techsupport@onemedical.com">techsupport@onemedical.com</a>
      </p>
    </div>
  </div>
</div>
